<template>
  <div class="slideshow">
    <div class="images-grid">
      <img
        v-for="(img, index) in visibleImages"
        :key="index"
        :src="img"
        eager
        alt="media image"
      />
    </div>

    <button class="left" @click="prevImage">‹</button>
    <button class="right" @click="nextImage">›</button>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

/* Automatically import every image in /assets/img/media */
// Works in Vue CLI (webpack)
const context = require.context('@/assets/img/media', false, /\.(png|jpe?g)$/)
const images = context.keys().map((key) => context(key))


/* Randomize the order of images each page load */
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}
shuffle(images)

const currentIndex = ref(0)
const visibleCount = 6
let intervalId = null

const visibleImages = computed(() =>
  Array.from({ length: visibleCount }, (_, i) =>
    images[(currentIndex.value + i) % images.length]
  )
)

function nextImage() {
  currentIndex.value = (currentIndex.value + visibleCount) % images.length
}

function prevImage() {
  currentIndex.value = (currentIndex.value - visibleCount + images.length) % images.length
}

onMounted(() => {
  intervalId = setInterval(nextImage, 4000) // autoplay every 4s
})

onUnmounted(() => {
  clearInterval(intervalId)
})
</script>

<style scoped>
.slideshow {
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 1rem;
  justify-items: center;
  align-items: center;
  width: 100%;
  max-width: 2000px;
  margin: auto;
}

.images-grid img {
  width: 100%;
  aspect-ratio: 16 / 9; /* or 4/3, adjust if your media is taller */
  object-fit: cover;    /* ensures uniform size — zooms slightly if needed */
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  background-color: #000;
  transition: transform 0.4s ease;
}


.images-grid img:hover {
  transform: scale(1.03);
}

button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 3rem;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  z-index: 2;
  border-radius: 6px;
}

button.left {
  left: 20px;
}

button.right {
  right: 20px;
}

button:hover {
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
